// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"slider_wrapper__2zX2n","wrapperLeft":"slider_wrapperLeft__3HQXG","wrapperRight":"slider_wrapperRight__2X4uF","slide":"slider_slide__CsLY8"};